var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyTickMark = function SvgHappyTickMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.712 13.5a1.65 1.65 0 0 1-1.203.669h-.132c-.437 0-.857-.174-1.165-.484l-4.75-4.29a1.648 1.648 0 0 1 2.332-2.33l3.12 2.663a.33.33 0 0 0 .499-.038L13.008.693a1.648 1.648 0 1 1 2.659 1.949z"
  })));
};
export default SvgHappyTickMark;